import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  padding-bottom: 18px;

  ion-content {
    --background: url(/assets/layout-own-ai-dominate/summary_screens/summary-final-background.png)
      no-repeat center center / cover;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url(/assets/layout-own-ai-dominate/welcome/overlay-gradient.png)
        no-repeat center center / cover;
      backdrop-filter: blur(3px);
      z-index: 1;
      pointer-events: none;
    }

    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
      position: relative;
      z-index: 2;
    }
  }

  .title {
    margin-bottom: 8px;
  }
`;

export const Subtitle = styled(UiTypography)`
  margin-bottom: 16px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: auto;
  position: relative;
  z-index: 2;
`;
